import { createApi } from '@reduxjs/toolkit/query/react';
import type { UserSubscriptionType } from '../subscriptions.types';
import { ogBaseQuery } from '../../ogBaseQuery';

export type LbSubscriptionType = {
  subscriptionType: UserSubscriptionType;
};

export const subscriptions = createApi({
  baseQuery: ogBaseQuery(),
  reducerPath: 'subscriptionsOG',
  endpoints: (builder) => ({
    getSubscriptionType: builder.query<
      LbSubscriptionType,
      { userId: string; skipInstitutionCheck?: boolean; cacheBustKey?: string }
    >({
      query: (data) => {
        return {
          url: `users/${data.userId}/getSubscriptionType`,
          method: 'GET',
          params: {
            skipInstitutionCheck: data.skipInstitutionCheck ?? true,
          },
        };
      },
    }),
  }),
});

export const {
  endpoints: { getSubscriptionType },
  useGetSubscriptionTypeQuery,
} = subscriptions;
